import { ForgottenUserDataDetails } from "../types/forgottenUserDataTypes";

export const forgottenUserDataInitialValues: ForgottenUserDataDetails = {
  email: "",
  captchaToken: "",
};
